let module = angular.module('app.resources');

module.factory('ActivationCodes', ($resource) => {
  'ngInject';
  return $resource(
    `${API_ROOT}/account/activations/:id`,
    { id: '@id' },
    {
      activateAddon: {
        method: 'PUT',
        url: `${API_ROOT}/account/activations/:id/addon`,
      },
    }
  );
});

export default module;



// WEBPACK FOOTER //
// ./app/resources/activation-codes.js